import { render, staticRenderFns } from "./u-button-group.vue?vue&type=template&id=601096b6&scoped=true&"
import script from "./u-button-group.vue?vue&type=script&lang=js&"
export * from "./u-button-group.vue?vue&type=script&lang=js&"
import style0 from "./u-button-group.vue?vue&type=style&index=0&id=601096b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601096b6",
  null
  
)

export default component.exports